/*
  LA "Pairs well with" (snippets/la-esles.liquid). Seçili ürünleri tek seferde
  sepete ekler. Eşlere gizli `_pair` satır özelliği yazılır (değer: bu sayfadaki
  ürünün adı); bulut/atif-notu Worker'ı bunu sipariş notuna ve `pairs-well-with`
  etiketine çevirir. Dijital ürün: sepette zaten olanı ikinci kez eklemez.
*/
(function () {
  if (window.__laEsles) return;
  window.__laEsles = true;

  var paraBirimi = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var para;
  try { para = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: paraBirimi }); }
  catch (e) { para = { format: function (n) { return '$' + n.toFixed(2); } }; }

  function kur(kutu) {
    var oran = parseInt(kutu.getAttribute('data-esles-oran'), 10) || 0;
    var kutular = kutu.querySelectorAll('input[data-esles-variant]');
    var toplamEl = kutu.querySelector('[data-esles-toplam]');
    var eskiEl = kutu.querySelector('[data-esles-eski]');
    var kodNot = kutu.querySelector('[data-esles-kodnot]');
    var btn = kutu.querySelector('[data-esles-ekle]');
    var durum = kutu.querySelector('[data-esles-durum]');

    function hesapla() {
      var toplam = 0, adet = 0;
      kutular.forEach(function (k) { if (k.checked) { toplam += parseInt(k.getAttribute('data-esles-fiyat'), 10) || 0; adet++; } });
      if (oran && toplam) {
        var yeni = toplam - Math.round(toplam * oran / 100);
        eskiEl.textContent = para.format(toplam / 100); eskiEl.hidden = false;
        toplamEl.textContent = para.format(yeni / 100); kodNot.hidden = false;
      } else {
        eskiEl.hidden = true; kodNot.hidden = true;
        toplamEl.textContent = para.format(toplam / 100);
      }
      btn.disabled = adet === 0;
      btn.textContent = adet === kutular.length ? 'Add all ' + adet + ' to cart' : (adet ? 'Add selected (' + adet + ') to cart' : 'Select items');
    }
    kutular.forEach(function (k) { k.addEventListener('change', hesapla); });
    hesapla();

    btn.addEventListener('click', function () {
      var kaynak = kutu.getAttribute('data-esles-kaynak') || '';
      btn.disabled = true; durum.textContent = '';
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (sepet) {
        var sepette = {};
        (sepet.items || []).forEach(function (i) { sepette[String(i.variant_id)] = true; });
        var items = [];
        kutular.forEach(function (k) {
          if (!k.checked) return;
          var id = k.getAttribute('data-esles-variant');
          if (sepette[id]) return;
          var it = { id: parseInt(id, 10), quantity: 1 };
          if (!k.hasAttribute('data-esles-ana')) it.properties = { _pair: kaynak };
          items.push(it);
        });
        if (!items.length) { durum.textContent = 'Already in your cart.'; return null; }
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'Could not add'); });
          durum.textContent = 'Added to cart.';
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('theme:cart:change', { bubbles: true })); // kampanya kodu (la-kampanya.js)
          var cekmece = document.querySelector('cart-drawer');
          if (cekmece) setTimeout(function () { cekmece.dispatchEvent(new CustomEvent('theme:cart-drawer:show')); }, 350);
        });
      }).catch(function (e) { durum.textContent = e.message || 'Could not add to cart.'; })
        .then(function () { btn.disabled = false; });
    });
  }

  function basla() { document.querySelectorAll('[data-la-esles]').forEach(kur); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
})();
